import { render, staticRenderFns } from "./RenameTaskName.vue?vue&type=template&id=77ca4964"
import script from "./RenameTaskName.vue?vue&type=script&lang=js"
export * from "./RenameTaskName.vue?vue&type=script&lang=js"
import style0 from "./RenameTaskName.vue?vue&type=style&index=0&id=77ca4964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports